import React from "react";
import PropTypes from "prop-types";
import PureBudgetTable from "./PureBudgetTable";

import { budgetTypeMap } from "../../../constants";
import {
  lockFixedFirmModalText,
  lockGMPModalText,
  publishBudgetModalText,
  unlockLineitemText,
} from "../../../helpers/Budget";
import BudgetSummary from "../BudgetSummary/BudgetSummary";
import BudgetTableComments from "./BudgetTableComments";
import BudgetTableConfirmationModal from "./BudgetTableConfirmationModal";
import Modal from "../Modal/Modal";
// eslint-disable-next-line import/no-cycle
import DocumentView from "../DocumentView/DocumentView";
// eslint-disable-next-line import/no-cycle
import BudgetTablePendingUpdates from "../BudgetTablePendingUpdates/BudgetTablePendingUpdates";
import BudgetTableReallocateForm from "./BudgetTableReallocateForm";
import ExpenseDetailsModal from "../ExpenseForm/ExpenseDetailsModal";
import BudgetTableHoldbackForm from "./BudgetTableHoldbackForm";
import BudgetTableInLineForm from "./BudgetTableInLineForm";
import BudgetTableUpdateVendorForm from "./BudgetTableUpdateVendorForm";
import BudgetTableRejectVendorInvoiceForm from "./BudgetTableRejectVendorInvoiceForm";
import BackButton from "../WidgetEditorView/Header/BackButton";
import ActivateProjectForm from "../ActivateProjectForm";
import useBudgetTableData from "./useBudgetTableData";

const BudgetTable = ({
  projectId,
  onRowSelect,
  initialSelectedRows,
  documentModalView,
  onActivateProjectCallback,
  setIsLoading,
  hideSiteHeader,
  pullSummary,
  tableMiniMapContainerId,
  disableRowsWithRateAndNoUncommitedValuePending,
  disableContingencyLineitem,
  disableSelectAllCheckbox,
  disbaleRowActions,
  report,
  viaChangeOrder,
  setButtonActions,
  hideSiteHeaderTitle,
}) => {
  const {
    budgetId,
    currentUser,
    refetchBudget,
    budgetGroups,
    budgetType,
    budgetSummary,
    isLockGmp,
    isLockFixedFirm,
    isBudgetLocked,
    reallocation,
    holdback,
    vendorInfo,
    users,
    financialsConfiguration,
    systemConfiguration,
    project,
    tableData,
    selectedRows,
    templateSettings,
    vendors,
    unitsOfMeasure,
    groupedUnitsOfMeasure,
    csiCodes,
    commentsData,
    rateSheetRates,
    setSelectedTimesheetRows,
    selectedDocumentsRows,
    setSelectedDocumentRows,
    pendingFinDocsUpdates,
    pendingVendorInvoicesUpdates,
    pendingInvoicesUpdates,
    selectedExpenseRows,
    setSelectedExpenseRows,
    pendingExpensesUpdates,
    pendingTimesheetsUpdates,
    spaceConfiguration,
    openDocumentDetails,
    setOpenDocumentDetails,
    openVendorInvoiceDetails,
    setOpenVendorInvoiceDetails,
    openInvoiceDetails,
    setOpenInvoiceDetails,
    openTimesheet,
    setOpenTimesheet,
    checkedRow,
    setCheckedRow,
    selectedLineItemForComments,
    setSelectedLineItemForComments,
    unlockLineitem,
    setUnlockLineitem,
    unlockLineitemUser,
    setUnlockLineitemUser,
    openDocument,
    setOpenDocument,
    openExpense,
    setOpenExpense,
    expenseData,
    timesheetData,
    isLoadingComments,
    isAllLowRangeChecked,
    isAllHighRangeChecked,
    showPublishBudgetModal,
    setShowPublishBudgetModal,
    showLockGMPModal,
    setShowLockGMPModal,
    showLockFixedFirmModal,
    setShowLockFixedFirmModal,
    showHoldbackModal,
    showEditSelectedModal,
    setEditSelectedModal,
    showUpdateVendorModal,
    isRejectOpen,
    setisRejectOpen,
    showPendingUpdatesQueue,
    setShowClientInvoice,
    projectClientInovice,
    isDraftProject,
    setActivateProjectModal,
    toggleLowRange,
    toggleHighRange,
    toggleAllHighRange,
    toggleAllLowRange,
    updateUserTemplateSettings,
    deleteUserTemplateSettings,
    versionCloseCallback,
    confirmLineitemUnlock,
    rowAssociationMenuList,
    onAddBudgetGroup,
    onEditBudgetGroup,
    onDeleteBudgetGroup,
    onEditSelectedSave,
    onAddSaveCallback,
    onSplitLineSaveCallback,
    onEditSaveCallback,
    validationSchema,
    initialNewRowStateInTableEditing,
    onStartEditingTableCallback,
    onStopEditingTableCallback,
    onSaveTableEdits,
    onCancelSaveCallback,
    onFavoriteClick,
    onDeleteRowClick,
    onEditRowCancelClick,
    groupByCallback,
    getButtonActions,
    handlePostComment,
    handlePostReply,
    onSaveProjectLocation,
    onSaveProjectLocationSpace,
    confirmPublishBudget,
    confirmLockGMP,
    confirmLockFixedFirm,
    handleRowSelect,
    onReloadUsers,
    onEditPopoverOpenCallback,
    onEditPopoverCloseCallback,
    onPendingUpdatesQueueClick,
    onMergePendingUpdates,
    onUpdateVendorClose,
    onChangeReallocationAmount,
    onUpdateVendorSubmit,
    onUpdateVendorChange,
    onChangeHoldbackAmount,
    isReallocationDisabled,
    isHoldbackDisabled,
    onReallocationClose,
    onReallocationSubmit,
    onHoldbackClose,
    onHoldbackSubmit,
    onRejectCancel,
    onRejectConfirm,
    showBudgetTableView,
    showInvoiceView,
    showActivateView,
  } = useBudgetTableData({
    projectId,
    onRowSelect,
    initialSelectedRows,
    setIsLoading,
    pullSummary,
    disableRowsWithRateAndNoUncommitedValuePending,
    disableContingencyLineitem,
    disbaleRowActions,
    report,
    setButtonActions,
  });

  return (
    <>
      {showBudgetTableView && (
        <PureBudgetTable
          initialNewRowStateInTableEditing={initialNewRowStateInTableEditing}
          onSaveTableEdits={onSaveTableEdits}
          onStartEditingTableCallback={onStartEditingTableCallback}
          onStopEditingTableCallback={onStopEditingTableCallback}
          disableTableEditing={isBudgetLocked || isLockGmp || isLockFixedFirm}
          validationSchema={validationSchema}
          data={tableData}
          tableMiniMapContainerId={tableMiniMapContainerId}
          name="budgetLineItems"
          // projectBuildings={projectBuildings}
          csiCodes={csiCodes}
          groupedUnitsOfMeasure={groupedUnitsOfMeasure}
          unitsOfMeasure={unitsOfMeasure}
          vendors={vendors}
          rateSheetRates={rateSheetRates}
          onEditRowCancelClick={onEditRowCancelClick}
          onDeleteRowClick={onDeleteRowClick}
          templateSettings={templateSettings}
          updateUserTemplateSettings={updateUserTemplateSettings}
          deleteUserTemplateSettings={deleteUserTemplateSettings}
          onEditSaveCallback={onEditSaveCallback}
          onAddSaveCallback={onAddSaveCallback}
          onCancelSaveCallback={onCancelSaveCallback}
          onSplitLineSaveCallback={onSplitLineSaveCallback}
          rowAssociationMenuList={rowAssociationMenuList}
          groupByCallback={groupByCallback}
          versionCloseCallback={versionCloseCallback}
          setSelectedRows={handleRowSelect}
          initialSelectedRows={selectedRows}
          buttonActions={getButtonActions()}
          onFavoriteClick={onFavoriteClick}
          isFixedFirmBudgetType={budgetType?.label === budgetTypeMap.fixedFirm}
          isCostPlusBudgetType={budgetType?.label === budgetTypeMap.costPlus}
          isTimeAndMaterialsBudgetType={
            budgetType?.label === budgetTypeMap.timeAndMaterials
          }
          hasEditPermission={currentUser?.hasPermission?.(
            "budget",
            "can_write"
          )}
          summaryComponent={
            <BudgetSummary
              budgetSummary={budgetSummary}
              fee={project?.contractualFee}
              insurance={project?.contractualInsurance}
              budgetType={budgetType?.label}
              isLockGmp={isLockGmp}
              isLockFixedFirm={isLockFixedFirm}
            />
          }
          budgetGroups={budgetGroups}
          setSelectedLineItemForComments={setSelectedLineItemForComments}
          onSaveProjectLocation={onSaveProjectLocation}
          projectLocationSpaceConfiguration={spaceConfiguration}
          onSaveProjectLocationSpace={onSaveProjectLocationSpace}
          onSaveContactCallback={onReloadUsers}
          systemConfiguration={systemConfiguration}
          users={users}
          isDraftProject={project?.status === "draft"}
          documentModalView={documentModalView}
          setOpenDocument={setOpenDocument}
          setOpenExpense={setOpenExpense}
          onEditPopoverOpenCallback={onEditPopoverOpenCallback}
          onEditPopoverCloseCallback={onEditPopoverCloseCallback}
          toggleLowRange={toggleLowRange}
          toggleHighRange={toggleHighRange}
          toggleAllHighRange={toggleAllHighRange}
          toggleAllLowRange={toggleAllLowRange}
          isAllLowRangeChecked={isAllLowRangeChecked}
          isAllHighRangeChecked={isAllHighRangeChecked}
          onPendingUpdatesQueueClick={onPendingUpdatesQueueClick}
          onAddBudgetGroup={onAddBudgetGroup}
          onEditBudgetGroup={onEditBudgetGroup}
          onDeleteBudgetGroup={onDeleteBudgetGroup}
          hideSiteHeader={hideSiteHeader}
          isLockGmp={isLockGmp}
          isLockFixedFirm={isLockFixedFirm}
          currentUserReference={currentUser?.reference}
          disableSelectAll={
            reallocation?.reallocateFromLineitem || disableSelectAllCheckbox
          }
          currentUser={currentUser}
          pendingUpdatesTotal={
            pendingFinDocsUpdates.length +
            pendingVendorInvoicesUpdates.length +
            pendingExpensesUpdates.length +
            pendingTimesheetsUpdates.length +
            pendingInvoicesUpdates.length
          }
          showPendingUpdates={!isDraftProject}
          viaChangeOrder={viaChangeOrder}
          hideSiteHeaderTitle={hideSiteHeaderTitle}
        />
      )}
      {showInvoiceView && (
        <div>
          <BackButton
            onBackPressed={() => {
              setShowClientInvoice(false);
              refetchBudget();
            }}
          />
          <DocumentView
            docRef={projectClientInovice.reference}
            projId={projectId}
            hideSiteHeader
            hideDocumentActions
          />
        </div>
      )}
      {showActivateView && (
        <div className="-mt-4">
          <ActivateProjectForm
            projectId={projectId}
            setActivateProjectModal={setActivateProjectModal}
            onActivateProjectCallback={onActivateProjectCallback}
          />
        </div>
      )}
      <BudgetTableComments
        currentUser={currentUser}
        isOpen={!!selectedLineItemForComments}
        onRequestModalClose={() => setSelectedLineItemForComments(null)}
        commentsData={commentsData}
        handlePostComment={handlePostComment}
        handlePostReply={handlePostReply}
        isLoadingComments={isLoadingComments}
      />
      <BudgetTableConfirmationModal
        isOpen={
          showPublishBudgetModal ||
          showLockGMPModal ||
          showLockFixedFirmModal ||
          unlockLineitem
        }
        title={
          (showPublishBudgetModal && "Publish Budget") ||
          (showLockGMPModal && "Lock GMP") ||
          (showLockFixedFirmModal && "Lock Fixed Firm") ||
          (unlockLineitem && "Unlock Line Item")
        }
        primaryButtonTitle={
          (showPublishBudgetModal && "Publish") ||
          (showLockGMPModal && "Lock") ||
          (showLockFixedFirmModal && "Lock") ||
          (unlockLineitem && "Unlock")
        }
        primaryButtonOnClick={() => {
          if (showPublishBudgetModal) {
            confirmPublishBudget();
          } else if (showLockGMPModal) {
            confirmLockGMP();
          } else if (showLockFixedFirmModal) {
            confirmLockFixedFirm();
          } else {
            confirmLineitemUnlock();
          }
        }}
        onRequestModalClose={() => {
          if (showPublishBudgetModal) {
            setShowPublishBudgetModal(false);
          } else if (showLockGMPModal) {
            setShowLockGMPModal(false);
          } else if (showLockFixedFirmModal) {
            setShowLockFixedFirmModal(false);
          } else {
            setUnlockLineitem(null);
            setUnlockLineitemUser(null);
          }
        }}
        text={
          (showPublishBudgetModal && publishBudgetModalText) ||
          (showLockGMPModal && lockGMPModalText) ||
          (showLockFixedFirmModal && lockFixedFirmModalText) ||
          (unlockLineitem && unlockLineitemText(unlockLineitemUser))
        }
      />
      {isRejectOpen && (
        <Modal
          isOpen={isRejectOpen}
          title="Reject"
          onRequestModalClose={onRejectCancel}
          shouldCloseOnEsc
          hideFooter
          childContainerStyle={{
            height: "432px",
          }}
        >
          <BudgetTableRejectVendorInvoiceForm
            onRejectCancel={onRejectCancel}
            onRejectConfirm={onRejectConfirm}
          />
        </Modal>
      )}
      {openDocument && (
        <Modal
          isOpen={openDocument}
          onRequestModalClose={() => setOpenDocument(null)}
          shouldCloseOnOverlayClick
          shouldCloseOnEsc
          hideFooter
          inset="4rem 8rem"
          childContainerClassName="overflow-auto"
        >
          <DocumentView
            docRef={openDocument}
            projId={projectId}
            onCancel={() => setOpenDocument(null)}
            hideFloatingActionButtons
          />
        </Modal>
      )}
      {expenseData && (
        <ExpenseDetailsModal
          expenseData={expenseData}
          onCloseModal={() => setOpenExpense(null)}
          csiCodes={csiCodes}
          viewDetails
          disableEditing
          financialsConfiguration={financialsConfiguration}
        />
      )}
      {showPendingUpdatesQueue && (
        <Modal
          isOpen={showPendingUpdatesQueue}
          title="Pending Updates"
          onRequestModalClose={onPendingUpdatesQueueClick}
          shouldCloseOnOverlayClick
          shouldCloseOnEsc
          hideFooter
          inset="30% 25%"
          childContainerClassName="relative overflow-y-scroll"
        >
          <BudgetTablePendingUpdates
            finDocs={pendingFinDocsUpdates}
            vendorInvoices={pendingVendorInvoicesUpdates}
            invoices={pendingInvoicesUpdates}
            setSelectedTimesheetRows={setSelectedTimesheetRows}
            setSelectedDocumentRows={setSelectedDocumentRows}
            selectedDocumentsRows={selectedDocumentsRows}
            setSelectedExpenseRows={setSelectedExpenseRows}
            selectedExpenseRows={selectedExpenseRows}
            projectId={projectId}
            setOpenDocumentDetails={setOpenDocumentDetails}
            openDocumentDetails={openDocumentDetails}
            openVendorInvoiceDetails={openVendorInvoiceDetails}
            setOpenVendorInvoiceDetails={setOpenVendorInvoiceDetails}
            openInvoiceDetails={openInvoiceDetails}
            setOpenInvoiceDetails={setOpenInvoiceDetails}
            budgetId={budgetId}
            projectData={project}
            setOpenTimesheet={setOpenTimesheet}
            openTimesheet={openTimesheet}
            setOpenExpense={setOpenExpense}
            openExpense={openExpense}
            openExpenseData={expenseData}
            onMergePendingUpdates={onMergePendingUpdates}
            onPendingUpdatesQueueClick={onPendingUpdatesQueueClick}
            setCheckedRow={setCheckedRow}
            checkedRow={checkedRow}
            setisRejectOpen={setisRejectOpen}
            expenses={pendingExpensesUpdates}
            timesheets={pendingTimesheetsUpdates}
            openTimesheetData={timesheetData}
            disableMerge={!["draft"].includes(projectClientInovice?.status)}
          />
        </Modal>
      )}
      {reallocation?.reallocateToLineitem && (
        <Modal
          isOpen={reallocation?.reallocateToLineitem}
          title="REALLOCATE"
          onRequestModalClose={onReallocationClose}
          shouldCloseOnEsc
          hideFooter
          primaryButtonOnClick={onReallocationSubmit}
          primaryButtonTitle="Reallocate"
          tertiaryButtonTitle="Cancel"
          disabled={isReallocationDisabled()}
        >
          <BudgetTableReallocateForm
            onChangeReallocationAmount={onChangeReallocationAmount}
            reallocation={reallocation}
          />
        </Modal>
      )}
      {showHoldbackModal && (
        <Modal
          isOpen={showHoldbackModal}
          title="HOLDBACK"
          onRequestModalClose={onHoldbackClose}
          shouldCloseOnEsc
          hideFooter
          primaryButtonOnClick={onHoldbackSubmit}
          primaryButtonTitle="Holdback"
          tertiaryButtonTitle="Cancel"
          disabled={isHoldbackDisabled()}
        >
          <BudgetTableHoldbackForm
            onChangeHoldbackAmount={onChangeHoldbackAmount}
            holdback={holdback}
          />
        </Modal>
      )}
      {showUpdateVendorModal && (
        <Modal
          isOpen={showUpdateVendorModal}
          title="Vendor"
          onRequestModalClose={onUpdateVendorClose}
          shouldCloseOnEsc
          hideFooter
          primaryButtonOnClick={onUpdateVendorSubmit}
          primaryButtonTitle="Save"
          tertiaryButtonTitle="Cancel"
          childContainerClassName="h-96 overflow-visible"
        >
          <BudgetTableUpdateVendorForm
            onUpdateVendorChange={onUpdateVendorChange}
            vendorInfo={vendorInfo}
            vendors={vendors}
          />
        </Modal>
      )}
      {showEditSelectedModal && (
        <Modal
          isOpen={showEditSelectedModal}
          title="Edit Selected"
          onRequestModalClose={() => setEditSelectedModal(false)}
          shouldCloseOnOverlayClick
          shouldCloseOnEsc
          hideFooter
          childContainerClassName="relative"
          contentStyle={{ maxWidth: "75%" }}
        >
          <div className="static">
            <div className="flex overflow-x-auto">
              <BudgetTableInLineForm
                csiCodes={csiCodes}
                groupedUnitsOfMeasure={groupedUnitsOfMeasure}
                unitsOfMeasure={unitsOfMeasure}
                vendors={vendors}
                // projectBuildings={projectBuildings}
                budgetGroups={budgetGroups}
                onSaveProjectLocation={onSaveProjectLocation}
                projectLocationSpaceConfiguration={spaceConfiguration}
                onSaveProjectLocationSpace={onSaveProjectLocationSpace}
                onSaveContactCallback={onReloadUsers}
                systemConfiguration={systemConfiguration}
                users={users}
                rateSheetRates={rateSheetRates}
                onAddBudgetGroup={onAddBudgetGroup}
                onEditBudgetGroup={onEditBudgetGroup}
                onDeleteBudgetGroup={onDeleteBudgetGroup}
                currentUser={currentUser}
                onAddSaveCallback={onEditSelectedSave}
                hideCrossButton
                hideAddAnother
                disableRequiredFieldsValidation
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

BudgetTable.propTypes = {
  projectId: PropTypes.string,
  onRowSelect: PropTypes.func,
  initialSelectedRows: PropTypes.arrayOf(PropTypes.string),
  documentModalView: PropTypes.bool,
  onActivateProjectCallback: PropTypes.func,
  setIsLoading: PropTypes.func,
  setButtonActions: PropTypes.func,
  hideSiteHeader: PropTypes.bool,
  pullSummary: PropTypes.bool,
  tableMiniMapContainerId: PropTypes.string,
  disableRowsWithRateAndNoUncommitedValuePending: PropTypes.bool,
  disableContingencyLineitem: PropTypes.bool,
  disableSelectAllCheckbox: PropTypes.bool,
  disbaleRowActions: PropTypes.bool,
  report: PropTypes.bool,
  viaChangeOrder: PropTypes.bool,
  hideSiteHeaderTitle: PropTypes.bool,
};

BudgetTable.defaultProps = {
  projectId: undefined,
  setButtonActions: () => {},
  onRowSelect: undefined,
  initialSelectedRows: [],
  documentModalView: false,
  onActivateProjectCallback: () => {},
  setIsLoading: undefined,
  hideSiteHeader: undefined,
  pullSummary: undefined,
  tableMiniMapContainerId: undefined,
  disableRowsWithRateAndNoUncommitedValuePending: false,
  disableContingencyLineitem: false,
  disableSelectAllCheckbox: false,
  disbaleRowActions: false,
  report: false,
  viaChangeOrder: false,
  hideSiteHeaderTitle: false,
};

export default BudgetTable;
